const LISTAR_DADOS = (state, payload) => {
  state.items = payload?.data || []
  state.paginacao = {
    per_page: payload?.per_page || state.paginacao.per_page,
    current_page: payload?.current_page || 1,
    last_page: payload?.last_page || 1,
    total: payload?.total || 0,
    from: payload?.from || 0,
    to: payload?.to || 0
  }
}

const SELECIONAR = (state, payload) => {
  state.selecionado = payload
}

const ATUALIZAR_ITEM = (state, payload) => {
  state.items = state.items.map(item => item.id === payload.id ? { ...item, ...payload } : item)
  if (state.selecionado && state.selecionado.id === payload.id) {
    state.selecionado = { ...state.selecionado, ...payload }
  }
}

const INSERIR_ITEM = (state, payload) => {
  state.items = [payload, ...state.items]
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const SALVANDO = (state, payload) => {
  state.salvando = payload
}

const ATUALIZAR_FILTROS = (state, payload) => {
  state.filtros = { ...state.filtros, ...payload }
}

export {
  LISTAR_DADOS,
  SELECIONAR,
  ATUALIZAR_ITEM,
  INSERIR_ITEM,
  CARREGANDO,
  SALVANDO,
  ATUALIZAR_FILTROS
}
